//https://stackoverflow.com/questions/4959975/generate-random-number-between-two-numbers-in-javascript
function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}


module.exports = function ajax_with_retries(http_verb,
                                            data_type,
                                            get_url_function,
                                            retry_n_times,
                                            get_request_data_function,
                                            client_recoverable_error_callback,
                                            client_unrecoverable_error_callback,
                                            did_succeed_with_data_callback) {
    console.log('ajax');
    var url = get_url_function();
    var request_data = get_request_data_function ? get_request_data_function() : null;
    $.ajax({
        url: url,
        type: http_verb,
        dataType: data_type,
        data: request_data,
        tryCount: 0,
        retryLimit: retry_n_times,
        success: function (data) {
            console.log(sprintf('[%s][%s] success', this.url, this.data));
            console.log(data);
            did_succeed_with_data_callback(data);
        },
        error: function (xhr, textStatus, errorThrown) {
            console.log(arguments);
            if (textStatus === 'timeout') {
                console.log(sprintf('retry #[%d] for [%s]', this.tryCount, this.type));
                client_recoverable_error_callback('We are having some trouble making outgoing network ' +
                    'connections. Can you check your internet connection?');
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {
                    setTimeout(function () {
                        $.ajax(this);
                    }, self.randomIntFromInterval(100, 750));
                    return;
                }
                return;
            }

            console.error(arguments);
            console.error(this.data);
            // out of tries
            client_unrecoverable_error_callback(sprintf("We can't connect to the internet" +
                "--or some other kind of error has occured. " +
                "Please check your internet connection and try again.\n\n[%s]", textStatus));
        }
    });

};